import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { YieldOf } from 'types/utils';
import {
  fetchCustomersByStation as fetchCustomersByStationAction,
  fetchedCustomersByStation as fetchedCustomersByStationAction,
  fetchCustomersByOD as fetchCustomersByODAction,
  fetchedCustomersByOD as fetchedCustomersByODAction,
  refreshCustomersByStation as refreshCustomersByStationAction,
  refreshedCustomersByStation as refreshedCustomersByStationAction,
  exportCustomersByStation as exportCustomersByStationAction,
  exportedCustomersByStation as exportedCustomersByStationAction,
  refreshCustomersByOD as refreshCustomersByODAction,
  refreshedCustomersByOD as refreshedCustomersByODAction,
  exportCustomersByOD as exportCustomersByODAction,
  exportedCustomersByOD as exportedCustomersByODAction,
} from './actions';
import { logout } from '../api-auth/actions';

import getAPI from '../../api/iv-back';

type FetchCustomersByStationActionPayload = ReturnType<typeof fetchCustomersByStationAction>;
type FetchCustomersByODActionPayload = ReturnType<typeof fetchCustomersByODAction>;
type RefreshCustomersByStationPayload = ReturnType<typeof refreshCustomersByStationAction>;
type ExportCustomersByStationPayload = ReturnType<typeof exportCustomersByStationAction>;
type RefreshCustomersByODPayload = ReturnType<typeof refreshCustomersByODAction>;
type ExportCustomersByODPayload = ReturnType<typeof exportCustomersByODAction>;

function* fetchCustomersByStationSaga({ payload }: FetchCustomersByStationActionPayload) {
  const { fetchCustomersByStation } = getAPI();
  const response: YieldOf<typeof fetchCustomersByStation> = yield call(fetchCustomersByStation, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedCustomersByStationAction({ ...data, searchTimestamp: moment().format() }));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedCustomersByStationAction(undefined, error));
  }
}

function* fetchCustomersByODSaga({ payload }: FetchCustomersByODActionPayload) {
  const { fetchCustomersByOD } = getAPI();
  const response: YieldOf<typeof fetchCustomersByOD> = yield call(fetchCustomersByOD, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedCustomersByODAction({ ...data, searchTimestamp: moment().format() }));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedCustomersByODAction(undefined, error));
  }
}
function* refreshCustomersByODSaga({ payload }: RefreshCustomersByODPayload) {
  const { refreshCustomersByOD } = getAPI();
  const response: YieldOf<typeof refreshCustomersByOD> = yield call(refreshCustomersByOD, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(refreshedCustomersByODAction({ ...data, searchTimestamp: moment().format() }));
  } else {
    const error = problem || 'unknown';
    yield put(refreshedCustomersByODAction(undefined, error));
  }
}

function* exportCustomersByODSaga({ payload }: ExportCustomersByODPayload) {
  const { exportCustomersByOD } = getAPI();
  const response: YieldOf<typeof exportCustomersByOD> = yield call(exportCustomersByOD, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(exportedCustomersByODAction(data));
  } else {
    const error = problem || 'unknown';
    yield put(exportedCustomersByODAction(undefined, error));
  }
}

function* refreshCustomersByStationSaga({ payload }: RefreshCustomersByStationPayload) {
  const { refreshCustomersByStation } = getAPI();
  const response: YieldOf<typeof refreshCustomersByStation> = yield call(refreshCustomersByStation, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(refreshedCustomersByStationAction({ ...data, searchTimestamp: moment().format() }));
  } else {
    const error = problem || 'unknown';
    yield put(refreshedCustomersByStationAction(undefined, error));
  }
}

function* exportCustomersByStationSaga({ payload }: ExportCustomersByStationPayload) {
  const { exportCustomersByStation } = getAPI();
  const response: YieldOf<typeof exportCustomersByStation> = yield call(exportCustomersByStation, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(exportedCustomersByStationAction(data));
  } else {
    const error = problem || 'unknown';
    yield put(exportedCustomersByStationAction(undefined, error));
  }
}

export default function* customersListSaga() {
  yield takeLatest(fetchCustomersByStationAction.type, fetchCustomersByStationSaga);
  yield takeLatest(fetchCustomersByODAction.type, fetchCustomersByODSaga);
  yield takeLatest(refreshCustomersByStationAction.type, refreshCustomersByStationSaga);
  yield takeLatest(exportCustomersByStationAction.type, exportCustomersByStationSaga);
  yield takeLatest(refreshCustomersByODAction.type, refreshCustomersByODSaga);
  yield takeLatest(exportCustomersByODAction.type, exportCustomersByODSaga);
}
